import {AfterViewInit, Component, Inject, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DIALOG_CONFIG} from 'ac-infra';

@Component({
  selector: 'sip-reason-group-dialog',
  templateUrl: './sip-reason-group-dialog.component.html',
  styleUrls: ['./sip-reason-group-dialog.component.scss']
})
export class SipReasonGroupDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('sipReasonGroupDialog') sipReasonGroupDialog: NgForm;
  sipReasonGroup: any;

  constructor(@Inject(DIALOG_CONFIG) private dialogConfig) {
    this.sipReasonGroup = dialogConfig.dialogData;
    dialogConfig.submitButtonDisabled = true;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.sipReasonGroupDialog.form.statusChanges.subscribe(() => {
      this.dialogConfig.submitButtonDisabled = !this.sipReasonGroupDialog.form.valid;
    });
  }

}
